import { TableRow, TableCell, SvgIcon, Collapse, Typography, Box, useTheme } from '@mui/material';
import { Minus, Plus } from '../../../../assets';
import { FC, useState } from 'react';
import RecipeIngredients from './RecipeIngredients';
import { useRecipeDialog } from '../../context/RecipeDialogContext';
import { Recipe } from '../../../../app/services/api/generated';
import RoundAndFormatValue from '../../../../components/shared/RoundAndFormatValue';

type Props = {
  item: Recipe;
  currencyCode?: string;
}

const RecipeItemRow: FC<Props> = ({ item, currencyCode }) => {
  const { openRecipeDialog } = useRecipeDialog();
  const [isExpanded, setIsExpanded] = useState<boolean>(false);
  const theme = useTheme();

  const onEdit = () => {
    openRecipeDialog({ recipe: item, entityType: 1 });
  };

  return (
    <>
      <TableRow>
        <TableCell
          sx={{
            cursor: 'pointer',
          }}
          onClick={() => setIsExpanded(!isExpanded)}
        >
          <Box sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            verticalAlign: 'middle',
          }}>
            <SvgIcon>
              {isExpanded ? <Minus /> : <Plus />}
            </SvgIcon>
            <Typography variant='textXS'>
              {item.itemNumber}
            </Typography>
          </Box>
        </TableCell>
        <TableCell variant='clampedText'
          sx={{ minWidth: '160px' }}>
          <Typography variant='textXS'>
            {item.description}
          </Typography>
        </TableCell>
        <TableCell align="center">{item.status}</TableCell>
        <TableCell align="center">
          <RoundAndFormatValue
            value={item.costPriceOnHand ?? 0}
            currencyCode={currencyCode}
          />
        </TableCell>
      </TableRow>

      {isExpanded && (
        <>
          <TableRow sx={{
            borderBottom: '3px solid',
            borderTop: '3px solid',
            borderColor: theme.palette.custom.gray[400],
          }}>
            <TableCell colSpan={4}
              sx={{ p: 0, m: 0, border: 0, backgroundColor: theme.palette.common.white }}>
              <Collapse in={true}>
                <RecipeIngredients
                  ingredients={item.recipeComponents ?? []}
                  onEdit={onEdit}
                  currencyCode={currencyCode}
                  isV2Managed={item.isV2Managed}
                  v2RecipeId={item.v2RecipeId}
                />
              </Collapse>
            </TableCell>
          </TableRow>
          <TableRow sx={{ height: 0 }}>
          </TableRow>
        </>
      )
      }
    </>
  );
};

export default RecipeItemRow;